import { useTheme } from 'emotion-theming';
export default useTheme;
